import styled from 'styled-components';

export const GroupLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #000;
`;
